/** Custom hand sprite: click the pen tip to set the anchor; choose its size on screen. */

import { X } from "lucide-react";
import { fileUrl } from "../api";
import { useEditor } from "./store";
import { NumberField } from "./ui";

export function HandDialog({ assetId }: { assetId: string }) {
  const project = useEditor((s) => s.project)!;
  const a = project.assets.find((x) => x.id === assetId);
  const close = () => useEditor.getState().set({ panel: null });
  if (!a || !a.width || !a.height) return null;
  const w = a.width;
  const h = a.height;
  const anchor = a.anchor ?? { x: 0, y: 0 };
  const scale = a.scale ?? 1;
  const view = Math.min(1, 520 / Math.max(w, h));

  const setAnchor = (e: React.MouseEvent<HTMLDivElement>) => {
    const r = e.currentTarget.getBoundingClientRect();
    const x = Math.round(((e.clientX - r.left) / r.width) * w);
    const y = Math.round(((e.clientY - r.top) / r.height) * h);
    useEditor.getState().edit((d) => void (d.assets.find((x2) => x2.id === assetId)!.anchor = { x, y }));
  };

  return (
    <div className="modal-back" onPointerDown={close}>
      <div className="modal hand" onPointerDown={(e) => e.stopPropagation()}>
        <header>
          <h3>Hand: {a.name}</h3>
          <button className="icon" onClick={close}><X size={18} /></button>
        </header>
        <p className="muted small">Click the pen tip. That point follows the drawing; the rest of the image hangs from it.</p>
        <div className="hand-pick" style={{ width: w * view, height: h * view }} onClick={setAnchor}>
          <img src={fileUrl(project.id, a.file)} alt="" draggable={false} />
          <div className="anchor" style={{ left: anchor.x * view, top: anchor.y * view }} />
        </div>
        <NumberField label="Size" suffix="×" value={scale} step={0.01} min={0.05} max={4} digits={2}
          hint="Display size relative to the image, at 1080p" onChange={(v) => useEditor.getState().edit((d) => void (d.assets.find((x) => x.id === assetId)!.scale = v))} />
        <p className="muted small">On screen at 1080p: {Math.round(w * scale)} × {Math.round(h * scale)} px. Use it per element (Inspector → Hand) or as the project default.</p>
      </div>
    </div>
  );
}
